import React, { useState, useEffect, Fragment } from 'react'
import { Paper, Grid } from "@material-ui/core";
import { globalGetService } from '../../../utils_v2/globalApiServices';
import { withRouter } from 'react-router';
import { AuditListing, integrationAuditFilter, auditListHd } from '../components';
import checkApiStatus from '../../../utils';
import { EmptyCollection, PageLoader, TableListComp, FilterComponent } from '../../../shared_elements';
import STableLoader from '../../../shared_elements/components/skeleton_loader/STableLoader';
import { trackActivity } from '../../../utils/mixpanel';
import { useSnackbar } from 'notistack'

export const IntegrationAudit = () => {
    const {enqueueSnackbar} = useSnackbar()
    const [isLoading, setLoading] = useState(false);
    const [skeletonLoader, setSkeletonLoader] = useState(false);
    const [sortInfo, setSortInfo] = useState({ sort: '', sort_by: '' });
    const [filter, setFilter] = useState({});
    const [IntegrationAudit, setIntegrationAudit] = useState({ list: [], pagination: {} });

    useEffect(() => {
        getIntegrationAudit({ ...filter, per_page: 20 }, 'skeletonLoader')
        trackActivity('Integration-Audit Hanwha - Lease Management', {
            event_type: 'Page Visited',
            page_title: 'Integration-Audit Listing'
        });
    }, [])

    const getIntegrationAudit = (query = {}, loaderType) => {
        loaderType === 'skeletonLoader' ? setSkeletonLoader(true) : setLoading(true)
        globalGetService(`contracts/invoice-audit-log-report/`, query)
            .then(response => {
                if (checkApiStatus(response)) {
                    setIntegrationAudit({ list: response?.data?.data?.list || [], pagination: response?.data?.data?.pagination || {} });
                    delete query.page
                    delete query.per_page
                    delete query.sort
                    delete query.sort_by
                    setFilter(query)
                }
                loaderType === 'skeletonLoader' ? setSkeletonLoader(false) : setLoading(false)
            })
    }


    const createSortHandler = (sortField) => {
        setSortInfo((prev) => {
            const isSameField = prev.sort === sortField;
            const nextSortBy = isSameField ? prev.sort_by === 'asc' ? 'desc' : 'asc' : 'asc';
            getIntegrationAudit({ ...filter, sort: sortField, sort_by: nextSortBy, per_page: 20 }, 'pageLoader');
            return { sort: sortField, sort_by: nextSortBy };
        });
    };

    const getSentToSftp = (id) => {
        setLoading(true)
        globalGetService(`contracts/invoice-audit-log-report/move-log-report/${id}/`)
            .then(response => {
                  if (response?.data?.statusCode === 200) {
                    setLoading(false)
                    enqueueSnackbar(response?.data.message, { variant: 'success', anchorOrigin: { vertical: 'top', horizontal: 'right' } });
                }else{
                     setLoading(false)
                    enqueueSnackbar(response?.data?.message, { variant: 'error', anchorOrigin: { vertical: 'top', horizontal: 'right' } });
                }
            })
    }

    const filterObj = Object.assign({}, filter, delete filter.sort, delete filter.sortInfo)
    return (
        <section className='fis-audit' style={{ marginLeft: '80px', marginTop: '20px' }}>
            {skeletonLoader ? <STableLoader count={10} /> :
                <Fragment>
                    <Paper square style={{ padding: '6px 10px' }}>
                        <Grid container spacing={1} alignItems='center'>
                            <Grid item md={9}>
                                <FilterComponent
                                    filter={filterObj}
                                    filterMenu={integrationAuditFilter}
                                    getResponseBack={(applyFilter) => { getIntegrationAudit({ ...applyFilter, page: 1, per_page: IntegrationAudit.pagination.per_page }, 'pageLoader'); }}
                                />
                            </Grid>
                        </Grid>
                    </Paper>
                    <TableListComp
                        heads={auditListHd}
                        sort={sortInfo?.sort}
                        sort_by={sortInfo?.sort_by}
                        data={IntegrationAudit?.list.map((item, index) =>
                            <AuditListing
                                index={index}
                                item={item}
                                onSftpChange={(id)=>getSentToSftp(id)} 
                                />
                        )
                        }
                        createSortHandler={(key) => createSortHandler(key)}
                        onChangePage={(event, newPage) => { getIntegrationAudit({ ...filter, page: newPage + 1, per_page: IntegrationAudit.pagination.per_page, sort: sortInfo?.sort, sort_by: sortInfo?.sort_by }, 'pageLoader') }}
                        onChangeRowsPerPage={(event) => { getIntegrationAudit({ ...filter, page: 1, per_page: event.target.value, sort: sortInfo?.sort, sort_by: sortInfo?.sort_by }, 'pageLoader') }}
                        pagination={IntegrationAudit.pagination}
                        noRecord={IntegrationAudit.list.length ? null :
                            <EmptyCollection
                                title="No records found"
                            />
                        }
                    />
                </Fragment>
            }
            {isLoading ? <PageLoader /> : null}
        </section >
    )
}

export default withRouter(IntegrationAudit)